export default "__VITE_ASSET__CTUgzs7b__"